import axios from 'axios';

const baseUrl = 'http://192.168.1.21:3008';

export const getAchats = async () => {
  const response = await axios.get(`${baseUrl}/achat/all`);
  return response.data;
};

export const saveAchat = async data => {
  const response = await axios.post(`${baseUrl}/achat/ajouter`, {
    entete: data.entete,
    lignes: data.lignes
  });
  return response;
};
